import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { resolveMediaUrl } from './landingData';

const APP_STORE = 'https://apps.apple.com/pl/app/vroom/id6764661186?l=pl';
const PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.lexuuw.vroom.app';

export default function LandingHero({ feature, onLogin }) {
  const visualRef = useRef(null);

  useEffect(() => {
    if (!window.matchMedia('(pointer: fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const node = visualRef.current;
    if (!node) return undefined;
    const xTo = gsap.quickTo(node, 'rotationY', { duration: 0.7, ease: 'power3.out' });
    const yTo = gsap.quickTo(node, 'rotationX', { duration: 0.7, ease: 'power3.out' });
    const move = (event) => {
      const rect = node.getBoundingClientRect();
      xTo(((event.clientX - rect.left) / rect.width - 0.5) * 8);
      yTo(-((event.clientY - rect.top) / rect.height - 0.5) * 7);
    };
    const leave = () => { xTo(0); yTo(0); };
    node.addEventListener('pointermove', move);
    node.addEventListener('pointerleave', leave);
    return () => {
      node.removeEventListener('pointermove', move);
      node.removeEventListener('pointerleave', leave);
    };
  }, []);

  return (
    <header id="top" className="dl-hero">
      <div className="dl-hero-grid" aria-hidden="true" />
      <div className="dl-orbit dl-orbit-one" aria-hidden="true" />
      <div className="dl-orbit dl-orbit-two" aria-hidden="true" />
      <svg className="dl-route-line" viewBox="0 0 900 900" aria-hidden="true">
        <path d="M-20 735 C170 670 150 500 340 465 S475 220 700 280 S810 130 930 70" />
      </svg>
      <div className="dl-hero-inner">
        <div className="dl-hero-copy">
          <div className="dl-eyebrow dl-reveal"><span /> POLSKI EKOSYSTEM KIEROWCÓW</div>
          <h1 className="dl-hero-title">
            <span className="dl-title-mask"><b>Twoje miasto.</b></span>
            <span className="dl-title-mask"><b>Twoja <em>arena.</em></b></span>
          </h1>
          <p className="dl-hero-lead dl-reveal">Jedna aplikacja dla ludzi, których łączy droga. Odkrywaj, rywalizuj, buduj garaż i zobacz motoryzację swojego miasta na żywo.</p>
          <div className="dl-hero-actions dl-reveal">
            <a className="dl-button dl-button-primary dl-magnetic" href="#join"><span>Dołącz do VROOM</span><i>↗</i></a>
            <button className="dl-button dl-button-ghost" type="button" onClick={onLogin}>Mam już konto</button>
          </div>
          <div className="dl-store-row dl-reveal">
            <a href={APP_STORE} target="_blank" rel="noopener noreferrer" aria-label="Pobierz VROOM z App Store">
              <img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/pl-pl?size=250x83" alt="Pobierz w App Store" />
            </a>
            <a href={PLAY_STORE} target="_blank" rel="noopener noreferrer" aria-label="Pobierz VROOM z Google Play">
              <img className="dl-play-badge" src="https://play.google.com/intl/en_us/badges/static/images/badges/pl_badge_web_generic.png" alt="Pobierz z Google Play" />
            </a>
          </div>
        </div>
        <div className="dl-hero-stage" ref={visualRef}>
          <div className="dl-stage-label dl-stage-label-top"><span>LIVE SYSTEM</span><b>ONLINE</b></div>
          <div className="dl-phone dl-phone-hero">
            <div className="dl-phone-speaker" />
            <div className="dl-phone-screen">
              <img src={resolveMediaUrl(feature?.imageUrl)} alt={feature?.title || 'Aplikacja VROOM'} />
              <div className="dl-phone-sheen" />
            </div>
          </div>
          <div className="dl-stage-ring" aria-hidden="true" />
          <div className="dl-stage-stat dl-stage-stat-left"><small>TRYB</small><strong>LIVE</strong></div>
          <div className="dl-stage-stat dl-stage-stat-right"><small>SYSTEM</small><strong>VROOM / 01</strong></div>
        </div>
      </div>
      <a className="dl-scroll-cue" href="#experience"><span>SCROLL TO DRIVE</span><i /></a>
    </header>
  );
}
